import { isDev } from './is-dev.fn';

export async function updateCount(count: number): Promise<string | undefined> {
  if (isDev()) {
    return Promise.resolve('12');
  } else {
    const response = await fetch('/count', {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ count }),
    });
    const body: { count: number } | null | undefined = await response.json();

    if (body) {
      return body.count.toString();
    }

    return Promise.resolve(undefined);
  }
}
